import React, { useEffect } from 'react';
import Page from '../../components/layout/Page';
import ExternalLink from '../../components/ExternalLink';
import './index.css';

const GHS_URL = 'https://luma.com/e3ccpyvd';
const REUNION_URL = 'https://luma.com/c7ektvuv';

const _style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const GHSPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Page title="Global Happiness Summit 2026" className="landing-page" style={_style}>
      <div className="container text-center" style={{ maxWidth: '48em', marginTop: '2em', marginBottom: '3em' }}>
        <div style={{ marginBottom: '2em' }}>
          <img alt="HNP logo" src="/images/hnp-logo-192.png" style={{ height: '5em' }} />
        </div>

        <h1 style={{ color: 'rgb(87, 85, 217)', marginBottom: '0.35em' }}>
          🌍 Global Happiness Summit 2026
        </h1>
        <h2 style={{ color: 'rgb(87, 85, 217)', fontSize: '1.5em', marginBottom: '0.5em' }}>
          HNP Reunion
        </h2>
        <p style={{ fontSize: '1.1em', color: '#555', marginBottom: '1.5em' }}>
          Connect • Inspire • Transform
        </p>

        <blockquote
          style={{
            margin: '1.5em 0',
            paddingLeft: '1.25em',
            borderLeft: '4px solid rgb(87, 85, 217)',
            fontStyle: 'italic',
            fontSize: '1.2em',
            lineHeight: 1.6,
            color: '#333',
          }}
        >
          <p style={{ margin: 0 }}>
            Together for a Happier, Healthier World.
          </p>
        </blockquote>

        <div style={{ backgroundColor: 'rgb(255, 250, 240)', padding: '1.5em', borderRadius: '0.5em', marginBottom: '1.5em' }}>
          <p style={{ margin: 0, fontSize: '1.1em' }}>🗓 <strong>October 9th, 2026</strong> — 2 PM EST</p>
          <p style={{ margin: '0.5em 0 0', fontSize: '1.1em' }}>🗓 <strong>October 10th, 2026</strong> — 12 PM EST</p>
          <p style={{ margin: '0.5em 0 0', fontSize: '1.1em' }}>💻 Online</p>
        </div>

        <p style={{ fontSize: '1.1em', marginBottom: '1em' }}>👉 Register for both events:</p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.75em',
            marginBottom: '2.5em',
          }}
        >
          <ExternalLink href={GHS_URL} className="btn btn-lg" target="_blank" rel="noopener noreferrer">
            Register for Global Happiness Summit
          </ExternalLink>
          <ExternalLink href={REUNION_URL} className="btn btn-lg" target="_blank" rel="noopener noreferrer">
            Register for HNP Reunion
          </ExternalLink>
        </div>

        <img
          alt="Global Happiness Summit 2026 and HNP Reunion flyer"
          src="/images/hnp-reunion-ghs-2026-flyer.jpg"
          style={{ width: '100%', height: 'auto', borderRadius: '0.5em' }}
        />
      </div>
    </Page>
  );
};

export default GHSPage;
